import * as React from "react";

import "./privacy-policy-modal.scss";

import {cs}            from "@Common/react/chain-services";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

export const PrivacyPolicyModal = ({next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3({
        xdQaName: "Privacy Policy Modal",
        top: 20,
        width: 800,
        next, rootNext,
    })],
    () => (
        <div className="privacy-policy-modal-51t" xd-qa-type="modal" xd-qa-name="Privacy Policy">
            <h1 style={{ minHeight: "35px"}} xd-qa-type="label" xd-qa-name="Privacy Policy">Privacy Policy</h1>
            <div className="content">
                <h3>What personal information does the Xpressdocs website gather?</h3>
                <p style={{textAlign: "left"}}>
                    <span
                    style={{fontWeight: "bold"}}>Information you or your company gives us:</span> We
                    receive and store any information you enter on our website or give us in any
                    other
                    way. You can choose not to provide certain information; however, this may limit
                    you
                    from taking advantage of many of the website’s features. We use the information
                    that
                    you provide for such purposes as responding to your requests, customizing future
                    ordering for you, improving our service and communicating with you.
                </p>
                <p style={{textAlign: "left"}}>
                    <span style={{fontWeight: "bold"}}>Automatic information:</span> We
                    receive and store
                    certain types of information whenever you interact with us. For example, like
                    many
                    websites, we use “cookies,” and we obtain certain types of information when your
                    Web
                    browser accesses the Xpressdocs website. A number of companies offer utilities
                    designed to help you visit websites anonymously. Although we will not be able to
                    provide you with a personalized experience at the Xpressdocs website if we
                    cannot
                    recognize you, we want you to be aware that these tools exist.
                </p>
                <p style={{textAlign: "left"}}>
                    <span style={{fontWeight: "bold"}}>E-mail communications: </span> To
                    help us make the
                    e-mails we send you more useful and informative, we may receive a confirmation
                    when
                    you open e-mail from the Xpressdocs website if your computer supports such
                    capabilities. If you do not want to receive e-mail or other forms of
                    communication
                    from us, please contact us and let us know your wishes.
                </p>
                <p style={{textAlign: "left"}}>
                    <span style={{fontWeight: "bold"}}>Information from other sources: </span> We
                    may
                    receive information about you from other sources and add it to your account
                    information. Depending on the level of integration, your information may be
                    supplied
                    by integration with your company’s intranet system or your intranet provider’s
                    system, or it may be supplied as raw data from one or more of these sources with
                    prior authorization from the company.
                </p>
                <h3>What about “cookies”?</h3>
                <p style={{textAlign: "left"}}>
                    Cookies are alphanumeric identifiers that we transfer
                    to your computer’s hard drive
                    through your Web browser to enable our systems to recognize your browser and to
                    provide various features within the system. The Help portion of the toolbar on
                    most
                    browsers will tell you how to prevent your browser from accepting new cookies,
                    how
                    to have the browser notify you when you receive a new cookie, or how to disable
                    cookies altogether. However, we cannot guarantee that your browsing and shopping
                    experience will be optimal, or functional for that matter, so we suggest you at
                    the
                    least accept cookies originating from our website.
                </p>
                <h3>Does the Xpressdocs website share the information it receives? </h3>
                <p style={{textAlign: "left"}}>Information about our customers is an important part
                    of our business, and we are not
                    in the business of selling it to others.
                </p>
                <p style={{textAlign: "left"}}>
                    <span style={{fontWeight: "bold"}}>Agents and customer service: </span>We
                    do not
                    employ other companies and individuals to perform functions on our behalf. This
                    means that whenever and however you contact Xpressdocs you will be communicating
                    with an employee of Xpressdocs. Consequently, such communication will always be
                    bound by the conditions listed in this Privacy Policy.
                </p>
                <h3>How secure is information about me?
                </h3>
                <p style={{textAlign: "left"}}>It is important for you to protect against
                    unauthorized access to your password and
                    to your computer. Whenever you are using a shared computer, be sure to sign off
                    from
                    the website once you have finished using it.
                </p>
                <h3>Which information can I access?
                </h3>
                <p style={{textAlign: "left"}}>The Xpressdocs website gives you access to a broad
                    range of information about your
                    account and your interactions with the Xpressdocs website for the limited
                    purpose of
                    viewing and, in certain cases, updating that information.
                </p>
                <h3>What choices do I have regarding sharing my information with the Xpressdocs
                    website?
                </h3>
                <p style={{textAlign: "left"}}>As discussed elsewhere on this page, you can always
                    choose not to provide
                    information, even though it might be needed to make a purchase or to take
                    advantage
                    of the Xpressdocs website features and services.
                </p>
                <p style={{textAlign: "left"}}>If you do not want to receive e-mail or other
                    communication from us, please contact
                    us, and we will ensure that you receive no more communications from us.
                </p>
                <p style={{textAlign: "left"}}>The Help portion of the toolbar on most browsers will
                    tell you how to prevent your
                    browser from accepting new cookies, how to have the browser notify you when you
                    receive a new cookie, and how to disable cookies altogether. Please note that
                    you
                    will not be able to use important features of the Xpressdocs website if you do
                    not
                    use cookies.
                </p>
                <h3>Conditions of use, notices, and revisions
                </h3>
                <p style={{textAlign: "left"}}>If you choose to visit the Xpressdocs website, your
                    visit and any dispute over
                    privacy, including limitations on damages, arbitration of disputes, and
                    application
                    of the law of the state of Texas, is subject to this Privacy Policy and our
                    Conditions of Use. If you have any concern about privacy at the Xpressdocs
                    website,
                    please contact us with a thorough description, and we will try to resolve it.
                </p>
                <p style={{textAlign: "left"}}>Our business changes constantly, and our Privacy
                    Policy will change also. We may
                    e-mail periodic reminders of our Privacy Policy and conditions, unless you have
                    instructed us not to. Even so, you should check our website frequently to learn
                    about recent changes, if any. Unless stated otherwise, our current Privacy
                    Policy
                    applies to all information that we have about you and your account. We stand
                    behind
                    the promises we make and will never materially change our Privacy Policy to make
                    it
                    less protective of customer information collected in the past without the
                    consent of
                    affected customers.
                </p>
            </div>
        </div>
    ),
);
